export default "__VITE_ASSET__CxI4QEZ5__"